var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60588 4.48039C4.64941 3.43686 6.05387 3 7.50049 3C9.60373 3 11.0832 4.12267 12.0004 5.66661C12.9121 4.12453 14.3819 3 16.5005 3C17.9471 3 19.3516 3.43686 20.3951 4.48039C21.4421 5.52736 22.0005 7.05948 22.0005 9C22.0005 11.7743 20.3222 14.3542 18.4098 16.3632C16.4727 18.3982 14.1316 20.133 12.4611 21H11.5398C9.86935 20.133 7.5283 18.3982 5.59117 16.3632C3.67882 14.3542 2.00049 11.7743 2.00049 9C2.00049 7.05948 2.55891 5.52736 3.60588 4.48039Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.c041ceabce5d7ecaf8f07dcc89626e83.svg";
export { ForwardRef as ReactComponent };